import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import hero from "@/assets/tour-cambodia-21day-beach.jpg";

const itinerary = [
  { time: "7:30 AM – 5:30 PM", title: "Angkor Wat, Angkor Thom, Bayon & Ta Prohm", body: "Begin in Siem Reap with the great temples of Angkor. Overnight: 4★ hotel in Siem Reap." },
  { time: "8:00 AM – 5:30 PM", title: "Banteay Srei & Grand Circuit", body: "The pink sandstone of Banteay Srei and the Grand Circuit temples. Overnight: Siem Reap." },
  { time: "8:00 AM – 2:00 PM", title: "Kampong Phluk Floating Village", body: "Boat trip on Tonlé Sap to the stilt-house village of Kampong Phluk. Overnight: Siem Reap." },
  { time: "7:30 AM – 5:30 PM", title: "Phnom Kulen National Park", body: "1000 Lingas riverbed, the Giant Buddha and the waterfall. Overnight: Siem Reap." },
  { time: "7:30 AM – 6:30 PM", title: "Beng Mealea & Koh Ker", body: "Jungle ruin of Beng Mealea and the seven-tiered pyramid of Koh Ker. Overnight: Siem Reap." },
  { time: "6:30 AM – 3:00 PM", title: "Prek Toal Bird Sanctuary", body: "Dawn boat to the most important waterbird colony in Southeast Asia. Overnight: Siem Reap." },
  { time: "7:30 AM – 5:30 PM", title: "Spean Toap & Banteay Chhmar", body: "Drive west to remote Banteay Chhmar via the ancient bridge of Spean Toap. Overnight: eco-lodge / homestay." },
  { time: "Full Day", title: "Banteay Chhmar Temples & Village Life", body: "Slow day among the moated ruins and weaving cooperatives. Overnight: same homestay." },
  { time: "8:00 AM – 6:00 PM", title: "Transfer to Battambang", body: "Countryside drive south to Battambang. Overnight: 4★ hotel in Battambang." },
  { time: "7:30 AM – 4:00 PM", title: "Transfer to Kampong Cham", body: "Cross the central plains to the Mekong town of Kampong Cham. Overnight: hotel." },
  { time: "Morning + Afternoon", title: "Bamboo Bridge & Transfer to Kratie", body: "Morning at the seasonal bamboo bridge, afternoon transfer to Kratie. Overnight: riverside hotel." },
  { time: "7:30 AM – 2:00 PM", title: "Mekong Dolphins & Islands", body: "Boat to see the rare Irrawaddy dolphins and the Mekong islands. Overnight: Kratie." },
  { time: "Travel Day", title: "Transfer to Banlung, Ratanakiri", body: "Long drive northeast into the red-earth highlands. Overnight: lodge in Banlung." },
  { time: "Full Day", title: "Yeak Laom Lake, Waterfalls & Jungle", body: "Volcanic crater lake of Yeak Laom, jungle waterfalls and indigenous villages. Overnight: same lodge." },
  { time: "Travel Day", title: "Transfer to Sen Monorom, Mondulkiri", body: "Cross the highlands south to Mondulkiri. Overnight: eco-lodge." },
  { time: "Full Day", title: "Elephant Sanctuary, Waterfalls & Hill Views", body: "Visit an ethical elephant sanctuary and the Bou Sra waterfall. Overnight: eco-lodge." },
  { time: "Travel Day", title: "Transfer to Kampot", body: "Long transfer to the southern pepper coast town of Kampot. Overnight: boutique hotel." },
  { time: "Full Day", title: "Pepper Farms, Countryside & River Cruise", body: "Famous Kampot pepper plantations, salt fields and a sunset river cruise. Overnight: Kampot." },
  { time: "Free Day", title: "Bokor Mountain or Relax", body: "Optional Bokor Mountain day trip old French hill station and views of the Gulf. Overnight: Kampot." },
  { time: "Full Day", title: "Transfer to Sihanoukville & Ferry to Koh Rong", body: "Transfer to the coast and ferry across to Koh Rong island. Overnight: beach resort." },
  { time: "Free Day", title: "Beach, Snorkeling & Relaxation", body: "Snorkel, swim, or kayak the turquoise bays of Koh Rong. Overnight: Koh Rong." },
  { time: "Full Day", title: "Return to the Mainland", body: "Ferry back to Sihanoukville and onward transfer. Overnight: Sihanoukville / en route." },
  { time: "Full Day", title: "Transfer to Phnom Penh", body: "Drive to the capital with a riverside walk in the evening. Overnight: 4–5★ hotel in Phnom Penh." },
  { time: "8:00 AM – 5:00 PM", title: "Royal Palace, Tuol Sleng & Killing Fields", body: "Royal Palace and Silver Pagoda, the Tuol Sleng Genocide Museum and Choeung Ek. Overnight: Phnom Penh." },
  { time: "Flexible", title: "Free Time + Airport Transfer", body: "Free morning and transfer to Phnom Penh Airport for your onward flight." },
];

const Timeline = ({ items }: { items: typeof itinerary }) => (
  <ol className="space-y-px">
    {items.map((s, idx) => (
      <li
        key={idx}
        className="group grid grid-cols-[auto_1fr] md:grid-cols-[200px_1fr] gap-x-4 md:gap-x-12 min-w-0 border-t border-border py-8 md:py-10 transition-colors hover:bg-secondary/40 last:border-b"
      >
        <div className="flex flex-col items-start gap-y-2 text-base">
          <span className="font-display text-primary tabular-nums text-xl">
            {String(idx + 1).padStart(2, "0")}
          </span>
          <span className="uppercase tracking-[0.25em] text-primary text-xs md:text-base">
            {s.time}
          </span>
        </div>
        <div>
          <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3 transition-colors group-hover:text-primary">
            {s.title}
          </h3>
          <p className="text-muted-foreground font-light leading-relaxed text-lg max-w-2xl">
            {s.body}
          </p>
        </div>
      </li>
    ))}
  </ol>
);

const optionOne = {
  label: "OPTION 1STANDARD PRIVATE TOUR",
  pricePrivate: "$2,650 – $2,970 total (1–2 pax)",
  priceGroup: "$2,650 per person",
  includes: [
    "Private air-conditioned transport",
    "Hotel pickup and drop-off",
    "Drinking water",
  ],
  excludes: [
    "Accommodation",
    "Entrance fees",
    "Meals",
    "Tour guide",
    "Travel insurance",
  ],
};

const optionTwo = {
  label: "OPTION 2 ALL-INCLUSIVE",
  pricePrivate: "$5,800 – $7,200 total (1–2 pax)",
  priceGroup: "Extra person: +$1,800 – $2,500",
  includes: [
    "All accommodation — 4★ hotels",
    "All entrance fees",
    "Professional English-speaking guide",
    "Air-conditioned transportation, pickup & drop-off",
    "Breakfast & lunch from Day 2 to Day 24",
    "1 dinner show with traditional Khmer dance",
    "Complimentary bottled water & cold towels",
    "Photography guidance",
  ],
  excludes: ["Tips and gratuities", "Personal expenses", "Travel insurance"],
};

const TourCambodia25Day = () => {
  const [option, setOption] = useState(0);
  const opt = option === 0 ? optionOne : optionTwo;
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={hero}
          alt="Cambodia 25 day cultural and nature tour with French-speaking guide — beach sunset on the southern coast"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Twenty-Five Day Grand Tour</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              25 Days Across <em className="font-light">Cambodia</em> Siem Reap, Banteay Chhmar, Battambang, the Mekong, Ratanakiri, Mondulkiri, Kampot, Koh Rong &amp; Phnom Penh.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              Discover Cambodia in depth over 25 days from the legendary temples of Angkor Wat to remote jungle provinces, waterfalls, wildlife, Mekong River life and the tropical beaches of Koh Rong, ending in Phnom Penh.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · 25 Days</span>
              <span>Group · 1–15</span>
              <span>From $2,650 / pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— The Idea</p>
          <h2 className="font-display text-4xl leading-[1.05] mb-10 text-balance md:text-xl">
            All of Cambodia, in twenty-five unhurried days.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Six days at Angkor and Tonlé Sap, the remote moated city of Banteay Chhmar, Battambang's countryside, the Mekong river towns of Kampong Cham and Kratie with its rare Irrawaddy dolphins, the red-earth highlands of Ratanakiri and elephant forests of Mondulkiri, the pepper coast of Kampot, the white-sand bays of Koh Rong and finally the capital Phnom Penh.
            </p>
          </div>
        </div>
      </section>

      {/* ITINERARY */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Itinerary</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            Twenty-five days, day by day.
          </h2>
          <Timeline items={itinerary} />
        </div><BookingSidebar pricePerPerson={2650} tourTitle="25 Days Tour Across Cambodia" pricingTiers={[{ maxPax: 2, price: 2650 }, { maxPax: 6, price: 2970 }, { maxPax: 10, price: 3556 }]} /></div></div>
      </section>

      {/* PRICING TABS */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Pricing &amp; Inclusions</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-12 text-balance">
            Choose your level of comfort.
          </h2>

          <div role="tablist" aria-label="Pricing options" className="flex flex-wrap justify-center gap-10 md:gap-16 mb-16">
            {[optionOne, optionTwo].map((o, i) => {
              const isActive = i === option;
              return (
                <button
                  key={o.label}
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setOption(i)}
                  className={`relative pb-3 uppercase tracking-[0.3em] transition-colors text-base ${
                    isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {o.label}
                  <span
                    className={`absolute left-0 right-0 -bottom-px h-px transition-colors ${
                      isActive ? "bg-primary" : "bg-transparent"
                    }`}
                  />
                </button>
              );
            })}
          </div>

          <ul className="mb-12 space-y-4 font-light text-lg max-w-3xl mx-auto">
            <li className="border-b border-border pb-4 flex justify-between gap-6"><span>Private Tour (25 Days)</span><span className="text-right">{opt.pricePrivate}</span></li>
            <li className="pb-4 flex justify-between gap-6"><span>Group Tour</span><span className="text-right">{opt.priceGroup}</span></li>
          </ul>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-12">
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Includes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.includes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Excludes</p>
              <ul className="space-y-4 font-light text-lg">
                {opt.excludes.map((x) => (
                  <li key={x} className="border-b border-border pb-4 last:border-b-0">{x}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Modest clothing (shoulders &amp; knees covered)</li>
                <li>Comfortable walking shoes</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for breakfast</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p><span className="text-foreground">Weather.</span> Hot and dry weather is expected throughout this tour. Showers are possible but most days are dry. Midday is hot, though woodland sites stay low-humidity.</p>
            <p><span className="text-foreground">Food.</span> Khmer cuisine is similar to other Southeast Asian cooking but less spicy. Good bread is available thanks to French influence, and there's a wide range of local brews to try.</p>
            <p>Pickup time: 7:30 – 8:00 AM (exact time confirmed one day before). Tour ends 1:30 – 2:30 PM on the final day.</p>
            <p>Dress code: casual but respectful in temples (covered shoulders and knees). Comfortable walking shoes strongly recommended.</p>
            <p>Not wheelchair accessible. Children under 5 are not permitted. Maximum group size: 1–15 travellers in an air-conditioned vehicle.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Journey</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            Twenty-five days. From Angkor to the Mekong to Koh Rong.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourCambodia25Day;
